import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Eye, Lightning, Spinner } from '@phosphor-icons/react';

const BucketCount = ({ color, count, label }) => (
  <div className="flex items-center gap-1.5">
    <span className={`w-2.5 h-2.5 rounded-full ${color}`} />
    <span className={`font-semibold ${color.replace('bg-', 'text-').replace('-500', '-900')}`}>
      {count}
    </span>
    <span className="text-slate-600">{label}</span>
  </div>
);

const BulkActionsBar = ({
  readinessBuckets,
  autoConfirming,
  onEnterReviewMode,
  onAutoConfirm,
}) => {
  const total =
    readinessBuckets.ready.length +
    readinessBuckets.review.length +
    readinessBuckets.blocked.length;
  if (total === 0) return null;

  const reviewBadge =
    readinessBuckets.review.length + readinessBuckets.blocked.length;

  return (
    <div
      className="bg-gradient-to-r from-emerald-50 via-amber-50 to-white border border-slate-200 rounded-xl p-4 flex flex-wrap items-center justify-between gap-3"
      data-testid="bulk-actions-bar"
    >
      <div className="flex items-center gap-4 text-sm flex-wrap">
        {readinessBuckets.ready.length > 0 && (
          <BucketCount
            color="bg-emerald-500"
            count={readinessBuckets.ready.length}
            label="ready to confirm"
          />
        )}
        {readinessBuckets.review.length > 0 && (
          <BucketCount
            color="bg-amber-500"
            count={readinessBuckets.review.length}
            label="need review"
          />
        )}
        {readinessBuckets.blocked.length > 0 && (
          <BucketCount
            color="bg-red-500"
            count={readinessBuckets.blocked.length}
            label="blocked"
          />
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onEnterReviewMode}
          disabled={total === 0}
          data-testid="enter-review-mode-btn"
        >
          <Eye size={16} className="mr-1.5" />
          Review Mode
          {reviewBadge > 0 && (
            <Badge className="ml-2 bg-amber-100 text-amber-700 text-[10px]">
              {reviewBadge}
            </Badge>
          )}
        </Button>
        <Button
          onClick={onAutoConfirm}
          disabled={autoConfirming || readinessBuckets.ready.length === 0}
          className="bg-emerald-700 hover:bg-emerald-800 text-white"
          data-testid="auto-confirm-btn"
        >
          {autoConfirming ? (
            <>
              <Spinner size={16} className="animate-spin mr-1.5" /> Confirming…
            </>
          ) : (
            <>
              <Lightning size={16} className="mr-1.5" weight="fill" />
              Auto-Confirm{' '}
              {readinessBuckets.ready.length > 0
                ? `(${readinessBuckets.ready.length})`
                : ''}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;
